import React from 'react';

import { UrlHelpers } from '../../service/UrlHelpers';
import { BannerViewType, PcodeRenderData } from '../../typings/pcode';
import { CreativePreview } from '../CreativePreview/CreativePreview';

export class VideoCreativePreview extends React.PureComponent<{
    previewData: PcodeRenderData;
    previewUrl: string;
}> {
    render() {
        const { previewUrl, previewData } = this.props;
        let isSquareFormat = false;
        if (previewData.isSquareFormat !== undefined) {
            isSquareFormat = previewData.isSquareFormat;
        }
        let width = 0;
        let height = 0;
        if (previewData.size && previewData.size.width && previewData.size.height) {
            width = previewData.size.width;
            height = previewData.size.height;
            isSquareFormat = width === height;
        }

        // плеер с такими размерами может не отрисоваться, поэтому увеличиваем.
        if (width < 180 || height < 180) {
            width = isSquareFormat ? 450 : 800;
            height = 450;
        }

        if (UrlHelpers.isUrlValid(previewUrl)) {
            let batchId = '';
            const url = new URL(previewUrl);
            const matchResult = url.href.match(/\/video-additions\/([a-f0-9]+)\/preview/i);
            const clientId = url.searchParams.get('client_id') || undefined;

            if (matchResult && matchResult[1]) {
                batchId = matchResult[1];
            } else if (!clientId) {
                return null;
            }

            return (
                <CreativePreview
                    cspNonce={''}
                    batchId={batchId}
                    creativeId={''}
                    clientId={clientId}
                    width={width}
                    height={height}
                    previewType={BannerViewType.videoAdditionPreview}
                    ad={previewData.ads[0]}
                    isSquareFormat={isSquareFormat}
                />
            );
        }

        return null;
    }
}
